import type { ExtendedDocumentReference } from '@seen/core/models/document-references/documentReferences'
import { DotSeparator } from '@seen/ui'
import { type JSX, useState } from 'react'
import { DocumentReferenceSheet } from '#src/components/document-reference/DocumentReferenceSheet.tsx'
import { useCreatedBy } from '#src/hooks/useCreatedBy.ts'
import { useWarningReporter } from '#src/hooks/useWarningReporter.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

interface DocumentReferenceItemProps {
  documentReference: ExtendedDocumentReference
}

export function DocumentReferenceItem({
  documentReference,
}: DocumentReferenceItemProps): JSX.Element {
  useWarningReporter(
    !documentReference.author &&
      `${documentReference.reference.reference} missing author`
  )

  const { data: createdBy, isLoading: createdByIsLoading } = useCreatedBy(
    documentReference.reference
  )
  const [selectedDocument, setSelectedDocument] =
    useState<ExtendedDocumentReference | null>(null)

  return (
    <TimelineTextEntry
      actor={documentReference.author ?? createdBy ?? 'Unknown'}
      actorIsLoading={!documentReference.author && createdByIsLoading}
      time={documentReference.date}
      action={
        <>
          uploaded a document
          <DotSeparator />
          <button
            type="button"
            className="cursor-pointer text-left font-medium focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden"
            onClick={() => {
              setSelectedDocument(documentReference)
            }}
          >
            {documentReference.displayTitle}
          </button>
          <DocumentReferenceSheet
            documentReference={selectedDocument}
            open={!!selectedDocument}
            setOpen={(open) => {
              if (!open) {
                setSelectedDocument(null)
              }
            }}
            hideDelete
            hideParticipant
          />
        </>
      }
      reference={documentReference.reference}
      originTask={documentReference.queuedEditsOriginTask}
    />
  )
}
